import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconAmazonStyle0 = cosmosIconCss;

const CosmosIconAmazon$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAmazon extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'adb123518828a5dbdfccff2c06a6d9d30061b9ed', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '323f9700ad9f5299137ea98437ae0d6ab454dfe6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6e49324d2e9d8bd5035f77b3b82a6348605b3d7c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.43 14.998a.427.427 0 0 1-.484.05c-.571-.475-.747-.736-1.012-1.127-.05-.074-.102-.152-.161-.237-1.122 1.145-1.916 1.487-3.371 1.487-1.72 0-3.06-1.061-3.06-3.187 0-1.66.9-2.79 2.18-3.342.93-.41 2.17-.537 3.246-.647.207-.021.408-.042.6-.064v-.416c.003-.45.007-.953-.248-1.33-.25-.376-.728-.532-1.148-.532-.78 0-1.475.4-1.645 1.228-.035.185-.17.366-.354.374l-1.985-.212c-.166-.038-.35-.173-.304-.429.457-2.405 2.628-3.13 4.573-3.13.995 0 2.295.265 3.08 1.019.915.854.909 1.97.902 3.193l-.002.324v3.187c0 .855.317 1.282.65 1.732l.095.127.026.037c.133.184.161.405-.005.543-.418.348-1.16.996-1.568 1.358l-.006-.006Zm-2.445-2.816c.384-.675.383-1.31.382-2.06v-.551c-1.478 0-3.04.316-3.04 2.06 0 .882.457 1.48 1.242 1.48.576 0 1.09-.353 1.415-.929Z", fill: "currentColor" }), h("path", { key: '41fba952e7ff78395e91717eede9fd25b664687c', d: "M3.92 15.246c2.54 1.549 6.471 3.946 12.737.964.27-.113.459.075.192.416-.27.344-2.42 2.317-6.034 2.317-3.613 0-6.38-2.468-7.224-3.492-.232-.266.035-.386.192-.289l.137.084Z", fill: "currentColor" }), h("path", { key: '2fe03765b2123a536ca4e194706c1ba87b867a0b', d: "M16.86 15.023c.547-.068 1.418-.026 1.589.197.13.17-.005.933-.225 1.48-.222.545-.553.93-.736 1.078-.186.149-.322.091-.223-.132.102-.223.661-1.606.44-1.897-.206-.268-1.137-.17-1.57-.126l-.088.01-.224.022c-.187.021-.237.027-.264-.03-.072-.202.752-.537 1.3-.602Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconAmazonStyle0; }
}, [1, "cosmos-icon-amazon", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-amazon"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-amazon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAmazon$1);
            }
            break;
    } });
}

const CosmosIconAmazon = CosmosIconAmazon$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAmazon, defineCustomElement };
